import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Entry point for the portal's own logout leg (see AuthService.logout for the full chain).
 *
 * This is a guard rather than a component because the router-outlet lives inside the layout, which
 * is not rendered while the app is unauthorized — a routed component would never mount (the same
 * reason AuthCallbackComponent is only a placeholder). Guards run on navigation regardless.
 */
@Injectable()
export class SignoutGuard {

    constructor(private authService: AuthService) {
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        await this.authService.logout();
        // Always false: logout ends in a redirect away from the app, there is nothing to activate.
        return false;
    }
}
